<template>
  <button class="burger" :class="{'burger--open': isOpen }" @click="$emit('click')">
    <div class="burger__wrapper">
      <div class="burger__line"></div>
      <div class="burger__line"></div>
      <div class="burger__line"></div>
    </div>
  </button>
</template>


<script>
export default {
  props: ['isOpen']
}
</script>


<style lang="scss" scoped>
.burger {
  padding: 15px;
  margin-right: -15px;
  box-sizing: content-box;
  appearance: none;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;

  &--open{
    transform: translate(-6px,0);

    .burger__line{
      &:nth-child(2){
        display: none;
      }


      &:last-child {
        transform: rotate(45deg) translate(3px,0);
        transform-origin: right bottom;
      }

      &:first-child {
        transform: rotate(-45deg) translate(3px,0);
        transform-origin: right top;
      }
    }
  }

  &__wrapper {
    width: 30px;
    height: 20px;
    position: relative;
  }

  &__line {
    height: 4px;
    width: 100%;
    background: #001f5c;
    left: 0;
    position: absolute;
    border-radius: 1px;

    &:nth-child(2) {
      top: calc(50% - 2px);
    }

    &:last-child {
      bottom: 0;
    }

    &:first-child {
      top: 0;
    }
  }
}
</style>